import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';

const createPaginationItem = function (content) {
  let Tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'a';
  let extraClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return createElement(Tag, {
    className: `page-numbers ${extraClass}`
  }, content);
};

const previewPaginationNumbers = () => createElement(Fragment, null, createPaginationItem(1), createPaginationItem(2), createPaginationItem(3, 'span', 'current'), createPaginationItem(4), createPaginationItem(5), createPaginationItem('...', 'span', 'dots'), createPaginationItem(8));

export default function QueryPaginationNumbersEdit() {
  const paginationNumbers = previewPaginationNumbers();
  return createElement("div", useBlockProps(), paginationNumbers);
}
//# sourceMappingURL=edit.js.map